// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file common/v1/safe_html.proto (package github.common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/v1/safe_html.proto.
 */
export const file_common_v1_safe_html: GenFile = /*@__PURE__*/
  fileDesc("Chljb21tb24vdjEvc2FmZV9odG1sLnByb3RvEhBnaXRodWIuY29tbW9uLnYxIhkKCFNhZmVIdG1sEg0KBXZhbHVlGAEgASgJYgZwcm90bzM");

/**
 * HTML that has already been sanitized server-side and is safe to render
 * without further escaping on the client. Mirrors Rails' SafeHtml concept.
 *
 * Use this in place of `string` whenever a field's value will be inserted
 * into the DOM as HTML. Distinct from `google.protobuf.StringValue` so the
 * type system signals the safety contract; the wire encoding is the same
 * shape (`{"value": "..."}` in proto3 JSON).
 *
 * @generated from message github.common.v1.SafeHtml
 */
export type SafeHtml = Message<"github.common.v1.SafeHtml"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;
};

/**
 * Describes the message github.common.v1.SafeHtml.
 * Use `create(SafeHtmlSchema)` to create a new message.
 */
export const SafeHtmlSchema: GenMessage<SafeHtml> = /*@__PURE__*/
  messageDesc(file_common_v1_safe_html, 0);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(SafeHtmlSchema, "51ceea0e6f28")
